/*
  Prețul de lansare pe paginile de târguri pe oraș.

  Numără spre aceeași dată fixă pentru toți vizitatorii: data-sfarsit-local
  de pe banda [data-lansare], în ora României (Europe/Bucharest), oricare ar
  fi fusul orar al vizitatorului. Nu folosește cookie sau localStorage și nu
  pornește de la prima vizită, deci reîncărcarea nu schimbă nimic.

  Arată zile, ore și minute (fără secunde) și se actualizează o dată pe
  minut. Minutele se rotunjesc în sus, ca în ultimul minut să scrie „1 min”;
  când timpul se termină, banda și toate [data-lansare-element] dispar, deci
  nu apare niciodată 0 sau un timp negativ. [data-lansare-hero] (eticheta și
  numărătoarea din caseta hero-ului, ascunse din Liquid) apar doar cât timp
  lansarea e în desfășurare. Toate copiile numărătorii primesc aceleași valori.
*/
(function () {
  if (window.mcbOrasLansare) return;
  window.mcbOrasLansare = true;

  /* Câte minute e Bucureștiul înaintea UTC la momentul dat (120 sau 180). */
  function decalaj(moment) {
    var parti = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Bucharest',
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    })
      .formatToParts(new Date(moment))
      .forEach(function (p) {
        parti[p.type] = p.value;
      });
    var caUtc = Date.UTC(+parti.year, +parti.month - 1, +parti.day, +parti.hour % 24, +parti.minute);
    return Math.round((caUtc - Math.floor(moment / 60000) * 60000) / 60000);
  }

  /* „2026-11-30 23:59” în ora României -> milisecunde UTC. */
  function sfarsitUtc(banda) {
    var local = banda.getAttribute('data-sfarsit-local') || '';
    var m = local.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (m) {
      try {
        var caUtc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
        var rezultat = caUtc - decalaj(caUtc - 180 * 60000) * 60000;
        return caUtc - decalaj(rezultat) * 60000;
      } catch (e) {}
    }
    var iso = Date.parse(banda.getAttribute('data-sfarsit-iso') || '');
    return isNaN(iso) ? null : iso;
  }

  /* Numărătoarea apare în mai multe locuri (banda din ofertă, caseta din
     hero, banda fixă de pe telefon): toate copiile primesc aceleași valori. */
  function scrie(banda, atribut, valoare) {
    document.querySelectorAll('[' + atribut + ']').forEach(function (el) {
      el.textContent = valoare;
    });
  }

  function opreste() {
    document.querySelectorAll('[data-lansare-element]').forEach(function (el) {
      el.hidden = true;
    });
    document.querySelectorAll('[data-lansare-hero]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function porneste() {
    var banda = document.querySelector('[data-lansare]');
    if (!banda) return;
    var sfarsit = sfarsitUtc(banda);
    if (sfarsit === null) return opreste();

    function bifeaza() {
      var ramas = sfarsit - Date.now();
      if (ramas <= 0) return opreste();
      var minute = Math.ceil(ramas / 60000);
      var zile = Math.floor(minute / 1440);
      var ore = Math.floor((minute % 1440) / 60);
      var min = minute % 60;
      scrie(banda, 'data-lansare-zile', zile);
      scrie(banda, 'data-lansare-zile-u', zile === 1 ? 'zi' : 'zile');
      scrie(banda, 'data-lansare-ore', ore);
      scrie(banda, 'data-lansare-ore-u', ore === 1 ? 'oră' : 'ore');
      scrie(banda, 'data-lansare-minute', min);
      document.querySelectorAll('[data-lansare-hero]').forEach(function (el) {
        el.hidden = false;
      });
      /* următoarea bifă la schimbarea minutului */
      setTimeout(bifeaza, (ramas % 60000) + 50);
    }
    bifeaza();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
})();
